import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICustomerRefundRequest, ICustomerRefundState } from '../../types/store';
import { IGetAllRefundRequestsResponse } from '../../types/api/response/customerRefundResponse';

const initialState: ICustomerRefundState = {
  content: [],
  page: {
    size: 0,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
};

const customerRefundSlice = createSlice({
  name: 'customerRefundSlice',
  initialState,
  reducers: {
    setRefundRequests: (state, action: PayloadAction<IGetAllRefundRequestsResponse>) => {
      state.content = action.payload.content;
      state.page = action.payload.page;
    },
    updateRefundRequest: (state, action: PayloadAction<ICustomerRefundRequest>) => {
      const index = state.content.findIndex((r) => r.id === action.payload.id);
      if (index > -1) {
        state.content[index] = action.payload;
      }
    },
  },
});

export const { setRefundRequests, updateRefundRequest } = customerRefundSlice.actions;
export default customerRefundSlice.reducer;
